/* eslint-disable @angular-eslint/prefer-standalone */
import { Component } from '@angular/core';
import { ErrorCodeComponent } from './error-code.component';

@Component({
  selector: 'app-error-500',
  template: `
    <app-error-code
      code="500"
      title="Server went wrong!"
      message="we have an internal issue, please try refreshing."
    />
  `,
   imports: [ErrorCodeComponent],
})
export class Error500Component {}
